export const imageDataFromUrl = (url) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        resolve(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  });
};

export const getCroppedCanvas = (canvas, startPoint, endPoint) => {
  const scaleBy = 2;
  const canvasContext = canvas.getContext('2d');
  const imageData = canvasContext.getImageData(startPoint.x, startPoint.y, endPoint.x, endPoint.y);

  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = imageData.width * scaleBy;
  tempCanvas.height = imageData.height * scaleBy;
  tempCanvas.style.width = imageData.width + 'px';
  tempCanvas.style.height = imageData.height + 'px';
  tempCanvas.style.background = 'white';
  const tempCanvasContext = tempCanvas.getContext('2d');
  tempCanvasContext.fillStyle = "white";
  tempCanvasContext.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
  tempCanvasContext.scale(scaleBy, scaleBy);
  tempCanvasContext.putImageData(imageData, 0, 0);

  return tempCanvas;
};
